var _defs, _rect, _rect2, _path, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUcognetIconAUGate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#07121B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0B1D2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E0C6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 896,
    height: 896,
    rx: 220,
    fill: "url(#bgGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 896,
    height: 896,
    rx: 220,
    fill: "none",
    stroke: "#123047",
    strokeWidth: 10,
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 360 270 L 360 620 Q 360 760 512 760 Q 664 760 664 620 L 664 270",
    fill: "none",
    stroke: "url(#uGrad)",
    strokeWidth: 120,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 360 270 L 360 310",
    fill: "none",
    stroke: "#07121B",
    strokeWidth: 62.400000000000006,
    strokeLinecap: "round",
    opacity: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "559.2,662.7 559.2,717.3 512.0,744.6 464.8,717.3 464.8,662.7 512.0,635.4",
    fill: "#FF8A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcognetIconAUGate);
export default __webpack_public_path__ + "static/media/ucognet_icon_A_U-Gate.b66029f4f65611594322126c3668c7e2.svg";
export { ForwardRef as ReactComponent };